import React, { Fragment, useEffect, useState } from 'react';
import './NotFoundScreen.css';
import HeaderScreen from '../../Components/HeaderScreen/HeaderScreen';
import { Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getAuthUserFromSessionStorage, removeAuthUserFromSessionStorage } from '../constant';
import { INTERVIEWER } from '../roles';
import _ from 'lodash';

const NotFoundScreen = () => {
  const navigate = useNavigate();
  const [userDetails, setUserType] = useState(getAuthUserFromSessionStorage());

  const goToHomePage = () => {
    if (_.isUndefined(userDetails) || _.isNull(userDetails) || _.isEmpty(userDetails)) {
      navigate("/sign-in", { replace: true });
    } else if (userDetails.account_type === INTERVIEWER) {
      navigate("/interviewer-dashboard")
    } else {
      navigate("/dashboard")
    }
  }
  // console.log("userDetails", userDetails);

  return (
    <Fragment>
      <div className="container-fluid calendar-container fixed-padding">
        {
          userDetails && (
            <div className="row">
              <div className="col-12 px-0">
                <HeaderScreen />
              </div>
            </div>
          )
        }
        {/* nagaraj code */}
        <div className="row calendar-feednback-row">
          <div className="col-12" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "60vh" }}>
            <Card>
              <Card.Body style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <p>This URL does not exist. Please click here:</p>
                <Button variant="outline-primary" onClick={() => goToHomePage(false)}>Go to Home page</Button>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default NotFoundScreen;
